module.exports = __webpack_public_path__ + "static/media/12UNCTAD7.cbd863c7.jpg";